define([
	"dojo/_base/declare",
	"SiteAdmin/Locale",
	"./Renderer"
], function(declare,Locale,Renderer) {

	return declare(Renderer, {
		_getSuffix: function() {
			return Locale.TOOLTIP;
		},

		_getValue: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			var	type = Locale.getConfigurableAttributeType(ctx.getNode());
			var	id = Locale.getConfigurableAttributeId(ctx.getNode());
			return Locale.getTypeAttributeResource(type, id, this._getSuffix());
		}
	});
});